module.exports = __webpack_public_path__ + "static/media/photo2.7b561c49.avif";